import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import BackLink from 'components/BackLink';
import ContainerFixedFab from 'ui/ContainerFixedFab';
import { Icon, Button } from 'semantic-ui-react';
import API from 'utils/api';

class MenuProductCostIngredientsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: null,
      product: null,
      productId: null,
      productIngredients: [],
      isFabActive: false
    };
  }

  componentDidMount() {
    const productId = parseInt(this.props.match.params.productId);
    this.setState({ productId }, this.loadData);
  }

  loadData = () => {
    Promise.all([
      API.getProduct(this.state.productId),
      API.getProductIngredients(this.state.productId)
    ])
      .then(([productRes, ingredientsRes]) => {
        this.setState({
          product: productRes.data,
          productIngredients: ingredientsRes.data,
          loading: false
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          error: 'Error al cargar el producto',
          loading: false
        });
      });
  }

  handleAddIngredient = () => {
    this.setState({ isFabActive: true });
    setTimeout(() => this.setState({ isFabActive: false }), 200);
    this.props.history.push(`/menu/products/${this.state.productId}/ingredients/new`);
  }

  handleDeleteIngredient = (productIngredientId) => {
    const { productId } = this.state;
    API.deleteProductIngredient(productId, productIngredientId)
      .then(() => {
        this.setState(prev => ({
          productIngredients: prev.productIngredients.filter(pi => pi.id !== productIngredientId)
        }));
      })
      .catch((error) => {
        console.error(error);
        this.setState({ error: 'Error al eliminar el ingrediente' });
      });
  }

  render() {
    if (this.state.loading) {
      return (
        <div>
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name='spinner' size='large' />
            <p style={{ marginTop: '1em', color: '#666' }}>Cargando producto...</p>
          </div>
        </div>
      );
    }

    if (!this.state.product) {
      return (
        <div>
          <Header text="Error" />
          <div style={{
            color: '#db2828',
            margin: '1.5em 0',
            padding: '12px',
            backgroundColor: '#fff6f6',
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            No se encontró el producto
          </div>
          <BackLink onClick={() => this.props.history.push('/menu/products')} />
        </div>
      );
    }

    const { product, productId, productIngredients, isFabActive, error } = this.state;

    const fabStyle = {
      width: '56px',
      height: '56px',
      borderRadius: '50%',
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'all 0.15s ease-in-out',
      transform: isFabActive ? 'scale(0.95)' : 'scale(1)'
    };

    return (
      <div>
        <BackLink onClick={() => this.props.history.push(`/menu/products/${productId}`)} />
        <Header text={`${product.name}: Ingredientes`} />

        {error && (
          <div style={{
            color: '#db2828',
            margin: '1em 0',
            padding: '12px',
            backgroundColor: '#fff6f6',
            borderRadius: '4px'
          }}>
            {error}
          </div>
        )}

        {productIngredients.length === 0 ? (
          <p style={{ color: '#999', marginTop: '1.5em' }}>
            No hay ingredientes en la receta. Toca + para agregar.
          </p>
        ) : (
          <div style={{ marginTop: '1em' }}>
            {productIngredients.map(pi => (
              <div
                key={pi.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0'
                }}
              >
                <div>
                  <span style={{ fontSize: '1.1em', fontWeight: 'bold' }}>
                    {pi.ingredient.name}
                  </span>
                  <span style={{ marginLeft: '12px', color: '#666' }}>
                    {pi.quantity} {pi.unit}
                  </span>
                </div>
                <Button
                  icon
                  basic
                  size="small"
                  onClick={() => this.handleDeleteIngredient(pi.id)}
                >
                  <Icon name='trash alternate outline' />
                </Button>
              </div>
            ))}
          </div>
        )}

        <ContainerFixedFab>
          <Button
            circular
            primary
            icon
            style={fabStyle}
            onClick={this.handleAddIngredient}
          >
            <Icon name='plus' size="large" />
          </Button>
        </ContainerFixedFab>
      </div>
    );
  }
}

export default withRouter(MenuProductCostIngredientsForm);
